export const categories = [
  {
    value: 'admin',
    name: 'Admin & User Management',
    productServiceGroup: 'Cloud Directory',
  },
  {
    value: 'integrations',
    name: 'Integrations (AD, M365/Azure , Google Workspaces, Applications)',
    productServiceGroup: 'Cloud Directory',
  },
  {
    value: 'authentication',
    name: 'Authentication (RADIUS, Passwordless)',
    productServiceGroup: 'User Auth',
  },
  {
    value: 'security',
    name: 'Security Management (Conditional Access Policies, MFA)',
    productServiceGroup: 'User Auth',
  },
  {
    value: 'deviceManagement',
    name: 'Device Management (Agents, Commands, Policy Management, Patching)',
    productServiceGroup: 'Devices',
  },
  {
    value: 'reporting',
    name: 'Directory or System Insights (Reporting)',
    productServiceGroup: 'Data Services',
  },
  {
    value: 'userExperience',
    name: 'User Experience (Usability, Admin & User Portal, Settings)',
    productServiceGroup: 'Customer Experience',
  },
  {
    value: 'mtp',
    name: 'Multi-Tenant Features',
    productServiceGroup: 'MSP',
  },
];

export default {
  categories,
};
